import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { applyFilters } from "@wordpress/hooks";

// style
import "./assets/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Components
import Sidebar from "./components/Sidebar";
import Dashboard from "./components/tabs/Dashboard";
import Orders from "./components/tabs/Orders";
import Transactions from "./components/tabs/Transactions";
import Downloads from "./components/tabs/Downloads";
import Profile from "./components/tabs/Profile";
import Address from "./components/tabs/Address";
import Password from "./components/tabs/Password";
import SingleOrder from "./components/tabs/Orders/SingleOrder";

const App = () => {
	const [activeTab, setActiveTab] = useState(null);
	const [singleView, setSingleView] = useState({ show: false, component: null, id: null });

	useEffect(() => {
		const defaultTabs = [
			"dashboard",
			"orders",
			"transactions",
			"downloads",
			"profile",
			"address",
			"password",
		];

		const validTabs = applyFilters("easycommerce_dashboard_valid_tabs", defaultTabs);

		const singleViewRoutes = applyFilters("easycommerce_dashboard_single_views", [
			{
				match: /^orders\/(\d+)$/,
				component: (id) => <SingleOrder orderId={id} />,
			},
		]);

		const handleHashChange = () => {
			const newHash = window.location.hash.replace("#", "");

			// Reset
			setSingleView({ show: false, component: null, id: null });

			// Single view
			for (const route of singleViewRoutes) {
				const match = newHash.match(route.match);
				if (match) {
					setActiveTab(newHash.split("/")[0]); 
					setSingleView({
						show: true,
						component: route.component(match[1]),
						id: match[1],
					});
					return;
				}
			}
			if (newHash === "") {
				setActiveTab("dashboard");
			} else if (validTabs.includes(newHash)) {
				setActiveTab(newHash);
			}
		};

		window.addEventListener("hashchange", handleHashChange);
		handleHashChange();

		return () => {
			window.removeEventListener("hashchange", handleHashChange);
		};
	}, []);

	const defaultTabContentList = [
		{ id: "dashboard", component: <Dashboard /> },
		{ id: "orders", component: <Orders /> },
		{ id: "transactions", component: <Transactions /> },
		{ id: "downloads", component: <Downloads /> },
		{ id: "profile", component: <Profile /> },
		{ id: "address", component: <Address /> },
		{ id: "password", component: <Password /> },
	];

	const tabContentList = applyFilters(
		"easycommerce_dashboard_tab_content_list",
		defaultTabContentList
	);

	return (
		<>
			<div className="w-full flex flex-col gap-[50px] py-10">
				<div className="w-full flex border easycommerce-sidebar ec-db-md:flex-row flex-col border-ec-border rounded-lg">
					<Sidebar activeTab={activeTab} />

					<div className="easycommerce-dashboard-content-details ec-db-md:w-[calc(100%_-_268px)] w-full p-3 sm:p-[30px]">
						{singleView.show ? (
							singleView.component
						) : (
							tabContentList.find((tab) => tab.id === activeTab)?.component || null
						)}
					</div>
				</div>
			</div>

			<ToastContainer />
		</>
	);
};

const container = document.getElementById("easycommerce_dashboard_render");
const root = createRoot(container);
root.render(<App />);
